import type { FormatBundle } from '../format/bundle';
import { buildPassThroughBundle } from '../format/passthrough';
import { useLocalizationContext } from './useLocalizationContext';

/**
 * The formatters a screen renders with before it has been migrated: en-US, in the reader's zone.
 *
 * This is the bundle {@link useFormat} answers with while the rollout flag is off, handed out
 * regardless of the flag. It exists for the middle state where the core is on but a feature is
 * not yet allowed to follow the reader, so the feature can keep its legacy presentation without
 * naming a locale itself. An en-US reader gets the same strings from both hooks.
 *
 * The bundle is cached per zone, so it keeps its identity for the session and is safe in a
 * dependency array.
 *
 * @returns A bundle of the same type as {@link useFormat}, rendering as en-US.
 * @throws If no `<LocalizationProvider>` is mounted above the caller.
 */
export const usePassThroughFormat = (): FormatBundle =>
  buildPassThroughBundle(useLocalizationContext().preferences);
